var React = require('react');

function ChevronThin (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#3D714E;}\n"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M131,263.4l234.7,245.3c4.1,4.2,10.8,4.4,15.1,0.3c4.3-4.1,4.4-10.8,0.3-15.1L153.4,256L381,18\n\t\t\tc4.1-4.3,3.9-11-0.3-15.1c-2.1-2-4.7-3-7.4-3c-2.8,0-5.6,1.1-7.7,3.3L131,248.6C127,252.8,127,259.3,131,263.4z"})))]);
}

ChevronThin.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = ChevronThin;

ChevronThin.default = ChevronThin;
